import { render, staticRenderFns } from "./RouterAgreedSectionView.vue?vue&type=template&id=16085027&scoped=true&"
import script from "./RouterAgreedSectionView.vue?vue&type=script&lang=js&"
export * from "./RouterAgreedSectionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16085027",
  null
  
)

export default component.exports